import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';
import NavbarLogo from '../components/NavbarLogo';
import CardCoex from '../components/main/CardCoex';
import CardCoex2 from '../components/main/CardCoex2';
import CardCompany from '../components/main/CardCompany';
import CardCompany2 from '../components/main/CardCompany2';
import CardService from '../components/main/CardService';
import CardService2 from '../components/main/CardService2';
import CardWorker from '../components/main/CardWorker';
import PassCard from '../components/modal/PassCard';
import * as securityHelper from "../helper/SecurityHelper";
import axios from "axios";
import Snackbar from '../components/Snackbar';
import { useNavigate } from 'react-router-dom';
import { fn_loginHandlerCallback } from "../api/FnCmmn";

export default function Main() {
  const navigate = useNavigate();
  const [auth, setAuth] = useState('');
  const [passCard, setPassCard] = useState(false);
  const [userNm, setUserNm] = useState('');
  const [sttstcInfo, setSttstcInfo] = useState({});
  const user: any = securityHelper.getLoginUser();
  const [snackbarTxt, setSnackbarTxt] = useState('');
  const [endWork, setEndWork] = useState(false);

  useEffect(() => {
    if (snackbarTxt) {
      setTimeout(() => setSnackbarTxt(''), 2000)
    }
  }, [snackbarTxt]);

  useEffect(() => {
    setAuth(user.auth);
    setUserNm(user.name);
    fn_retrieveDashBrdSttstc();
    fn_retrieveTbmMngrEntrncTime();
  }, [])
  const fn_retrieveTbmMngrEntrncTime = async () => {
    const rtrnData = await axios.post('admin/api/tbm/retrieveTbmWrkTime', { userSeq: user.seq })
    const workEndTime = rtrnData.data.workEndTime;
    if (workEndTime) {
      setEndWork(true);
    }
  }

  const endHandler = async () => {
    let message = '작업을 종료하시겠습니까?';
    if (window.confirm(message)) {
      const rsltCnt = await fn_updateWorkEndInfoData();
      if (rsltCnt > 0) {
        setSnackbarTxt('작업이 정상적으로 종료 되었습니다.');
        setEndWork(true);
      } else {
        setSnackbarTxt('작업 종료에 실패 하였습니다.');
      }
    }
  };

  const restartHandler = async () => {
    let message = '';
    if (auth === 'KOX' || auth === 'COM' || auth === 'SRV') {
      message = '작업 종료 시간을 현재 시간으로 수정하시겠습니까?';
      if (window.confirm(message)) {
        const rsltCnt = await fn_updateWorkEndInfoData();
        if (rsltCnt > 0) {
          setSnackbarTxt('작업 종료 시간이 수정되었습니다.');
        }
      }
    } else if (auth === 'WOK') {
      message = '다른 작업을 시작 하시겠습니까?';
      if (window.confirm(message)) {
        navigate('/smart-TBM-list', { state: { exbtPlc: false, restart: true } })
      }
    }
  }

  const fn_updateWorkEndInfoData = async () => {
    console.log(user.smartTbmSeq)
    const rtrnData = await axios.post('admin/api/tbm/updateWorkEndInfoData', { auth: user.auth, userSeq: user.seq, smartTbmSeqStr: user.smartTbmSeq })
    return rtrnData.data;
  }

  const fn_retrieveDashBrdSttstc = async () => {
    let param = {};
    if (user.auth === 'KOX') {
      let koxCmpnySeq = (await axios.post('admin/api/sgst/retrieveKoxCmpnySeq', {})).data;
      param = { rgstCmpnySeq: user.companySeq, rgstDt: new Date(), auth: user.auth, rcptntSeq: koxCmpnySeq, date: new Date() };
    } else if (user.auth === 'COM') {
      param = { auth: user.auth, hstCmpnySeq: user.companySeq, rcptntSeq: user.companySeq, cmpnySeq: user.companySeq, date: new Date() };
    } else if (user.auth === 'SRV') {
      param = { auth: user.auth, chkTrgtCmpnySeq: user.companySeq, rgstDt: new Date(), rcptntSeq: user.companySeq, cmpnySeq: user.companySeq, date: new Date() }
    }
    const rtrnData = await axios.post('admin/api/cmmn/retrieveDashBrdSttstc', param);
    setSttstcInfo(rtrnData.data);
  }
  console.log(user)
  return (
    <div className='w-screen h-[calc(100dvh)] flex flex-col relative z-20'>
      {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
      {passCard && <PassCard setPassCard={setPassCard} />}
      <NavbarLogo />
      <div className='w-[90%] h-[calc(100%-116px)] md:h-[calc(100%-290px)] overflow-auto scrollbar-hide flex flex-col ml-auto mr-auto'>
        <div className='flex flex-col relative mt-[1rem] mb-10 md:mt-[2.5rem] md:mb-[25px]'>
          <p className='w-[83%] text-[1rem] sm:text-[1.125rem] md:text-[2.6rem] ml-[0.938rem] md:ml-[2.3rem]'>{`${userNm}님, 오늘도 안전작업 하세요!`}</p>
          {auth === 'KOX' && <><CardCoex sttstcInfo={sttstcInfo} /><CardCoex2 setPassCard={setPassCard} /></>}
          {auth === 'COM' && <><CardCompany sttstcInfo={sttstcInfo} /><CardCompany2 setPassCard={setPassCard} /></>}
          {auth === 'SRV' && <><CardService sttstcInfo={sttstcInfo} /><CardService2 /></>}
          {auth === 'WOK' && <CardWorker setPassCard={setPassCard} />}
        </div>
        <button onClick={!endWork ? endHandler : restartHandler} className='py-12 md:py-[30px] mt-auto mx-auto mb-20 md:mb-[50px] flex justify-center items-center text-[0.938rem] md:text-[2.345rem] font-preLight w-[90%] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px]'>
          {!endWork ? '작업 종료' : '다시 작업을 시작하려면 버튼을 눌러주세요'}
        </button>
      </div>
      <Footer />
    </div>
  );
}